import { EditorUIContext } from '@app/components/cms/context/EditorUIContext';
import { Cms } from '@typings';
import React from 'react';

export const useIsInViewMode = (mode: Cms.ViewModeType) => React.useContext(EditorUIContext).viewMode === mode;
